












































































































































































































































































import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import SnackbarMixin from '@/mixins/snackbar';

import {
  ITimeOffPolicyData,
  ITimeOffTypeData,
  TimeOffDurationType
} from '@/models';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import TimeOffPolicyFormDialog from '@/components/time-off-calendar/TimeOffPolicyFormDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ALPage from '@/components/core/Page/ALPage.vue';

const baseMixins = mixins(SnackbarMixin, Functions, auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    files: HTMLInputElement;
    timeOffPolicyFormDialog: InstanceType<typeof TimeOffPolicyFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      ErrorAlert,
      TimeOffPolicyFormDialog,
      ConfirmationDialog,
      ALPage
    },
    data() {
      return {
        TimeOffDurationType,

        loading: false,
        deleteDialog: false,

        rollOverLoading: false,
        rollOverAllEntitlmentsDialog: false,
        applyRollOverEntitlmentsDialog: false,
        confirmDialogErrorMessage: '',

        sortBy: 'id',
        sortDesc: true,

        search: '',

        errorMessage: '',
        errorMessageDetail: '',

        selectedYear: new Date().getFullYear(),

        selectedTimeOffPolicy: null as ITimeOffPolicyData | null,

        headers: [
          {
            text: 'Time Off',
            sortable: false,
            value: 'timeoff',
            width: 200
          },
          {
            text: 'Effective Date',
            sortable: false,
            value: 'effective_date',
            width: 200
          },
          {
            text: 'Expiry Date',
            sortable: false,
            value: 'expiry_date',
            width: 200
          },
          {
            text: 'Yearly Entitlement',
            sortable: false,
            value: 'yearly_entitlement',
            align: 'end',
            width: 180
          },
          {
            text: 'Time Off Unit',
            sortable: false,
            value: 'timeoff_unit.display_unit',
            width: 180
          },
          {
            text: 'Is Accrual Supported',
            sortable: false,
            value: 'is_accrual_supported',
            align: 'center',
            width: 150
          },
          {
            text: '',
            sortable: false,
            value: 'actions',
            align: 'center',
            width: 120
          }
        ],
        page: 1
      };
    },

    computed: {
      ...mapGetters({
        timeOffPolicies: 'timeOff/getTimeOffPolicies'
      })
    },

    async mounted() {
      this.loading = true;
      this.clearAllErrors();
      this.fetchTimeOffPolicies()
        .catch(error => {
          if (error.response && error.response.data.detail) {
            this.errorMessageDetail = error.response.data.detail;
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      moment,

      ...mapActions({
        fetchTimeOffPolicies: 'timeOff/fetchTimeOffPolicies',
        deleteTimeOffPolicy: 'timeOff/deleteTimeOffPolicy',
        rollOverEntitlement: 'timeOff/rollOverEntitlement',
        incrementEntitlementYears: 'timeOff/incrementEntitlementYears'
      }),

      openTimsOffPolicyDialog(policy?: ITimeOffTypeData) {
        this.$refs.timeOffPolicyFormDialog.open(policy);
      },

      openDeletePolicy(item: ITimeOffPolicyData) {
        this.clearAllErrors();
        this.selectedTimeOffPolicy = item;
        this.deleteDialog = true;
      },

      closePolicyDeleteDialog() {
        this.deleteDialog = false;
        this.selectedTimeOffPolicy = null;
      },

      genRollOverAllEntitlements() {
        this.rollOverLoading = true;

        this.clearAllErrors();
        this.incrementEntitlementYears(this.selectedYear)
          .then(() => {
            this.createSnack({
              color: 'success',
              type: 'success',
              right: true,
              useBtn: false,
              msg: `Entitlements have been successfully incremented`,
              btnText: 'Close',
              timeout: 6000,
              action: function() {}
            });
            this.rollOverAllEntitlmentsDialog = false;
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.confirmDialogErrorMessage = error.response.data.detail;
            } else {
              this.confirmDialogErrorMessage = ErrorManager.extractApiError(
                error
              );
            }
          })
          .finally(() => {
            this.rollOverLoading = false;
          });
      },

      applyRollOverEntitlements() {
        this.rollOverLoading = true;

        this.clearAllErrors();
        this.rollOverEntitlement()
          .then(() => {
            this.createSnack({
              color: 'success',
              type: 'success',
              right: true,
              useBtn: false,
              msg: `Entitlements have been successfully rolled over`,
              btnText: 'Close',
              timeout: 6000,
              action: function() {}
            });
          })
          .then(() => {
            this.applyRollOverEntitlmentsDialog = false;
          })
          .catch(error => {
            // TODO: LH - 2023-02-27 - look into using ErrorAlert to display errors to handle `errorMessage` and a `detailErrorMessage`
            if (error.response && error.response.data.detail) {
              this.confirmDialogErrorMessage = error.response.data.detail;
            } else {
              this.confirmDialogErrorMessage = ErrorManager.extractApiError(
                error
              );
            }
          })
          .finally(() => {
            this.rollOverLoading = false;
          });
      },

      removePolicy(item: ITimeOffPolicyData) {
        this.loading = true;

        this.clearAllErrors();
        this.deleteTimeOffPolicy(item.id)
          .then(() => {
            this.closePolicyDeleteDialog();
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.confirmDialogErrorMessage = error.response.data.detail;
            } else {
              this.confirmDialogErrorMessage = ErrorManager.extractApiError(
                error
              );
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.errorMessageDetail = '';

        this.confirmDialogErrorMessage = '';
      }
    }
  });
